"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIRegisterServices = exports.isFactoryDefinition = exports.isParameterDefinition = exports.isServiceDefinition = void 0;
function isServiceDefinition(value) {
    return "service" in value;
}
exports.isServiceDefinition = isServiceDefinition;
function isParameterDefinition(value) {
    return "parameter" in value;
}
exports.isParameterDefinition = isParameterDefinition;
function isFactoryDefinition(value) {
    return "factory" in value;
}
exports.isFactoryDefinition = isFactoryDefinition;
function isIRegisterServices(value) {
    return "register" in value;
}
exports.isIRegisterServices = isIRegisterServices;
//# sourceMappingURL=IRegisterServices.js.map